import React from 'react';
import Box from '@alucio/lux-ui/src/components/layout/Box/Box';
import findChildren from '@alucio/lux-ui/src/util/findChildren';
import mergeStyles from '@alucio/lux-ui/src/components/util/mergeStyles';
var AnchorEnum;
(function (AnchorEnum) {
    AnchorEnum[AnchorEnum["center"] = 0] = "center";
    AnchorEnum[AnchorEnum["left"] = 1] = "left";
    AnchorEnum[AnchorEnum["right"] = 2] = "right";
    AnchorEnum[AnchorEnum["top"] = 3] = "top";
    AnchorEnum[AnchorEnum["bottom"] = 4] = "bottom";
    AnchorEnum[AnchorEnum["topLeft"] = 5] = "topLeft";
    AnchorEnum[AnchorEnum["bottomLeft"] = 6] = "bottomLeft";
    AnchorEnum[AnchorEnum["topRight"] = 7] = "topRight";
    AnchorEnum[AnchorEnum["bottomRight"] = 8] = "bottomRight";
})(AnchorEnum || (AnchorEnum = {}));
var AlignSelfEnum;
(function (AlignSelfEnum) {
    AlignSelfEnum[AlignSelfEnum["flex-start"] = 0] = "flex-start";
    AlignSelfEnum[AlignSelfEnum["center"] = 1] = "center";
    AlignSelfEnum[AlignSelfEnum["flex-end"] = 2] = "flex-end";
    AlignSelfEnum[AlignSelfEnum["stretch"] = 3] = "stretch";
    AlignSelfEnum[AlignSelfEnum["baseline"] = 4] = "baseline";
})(AlignSelfEnum || (AlignSelfEnum = {}));
// [NOTE]: RN doesn't support translateX/Y as strings natively, but works fine in web, so use any for record value for now
const anchorMap = {
    center: { top: '50%', left: '50%', transform: [{ translateX: '-50%' }, { translateY: '-50%' }] },
    top: { top: 0, left: '50%', transform: [{ translateX: '-50%' }] },
    topRight: { top: 0, right: 0 },
    right: { top: '50%', right: 0, transform: [{ translateY: '-50%' }] },
    bottomRight: { bottom: 0, right: 0 },
    bottom: { bottom: 0, left: '50%', transform: [{ translateX: '-50%' }] },
    bottomLeft: { bottom: 0, left: 0 },
    left: { top: '50%', left: 0, transform: [{ translateY: '-50%' }] },
    topLeft: { top: 0, left: 0 },
};
const S = {
    Outer: {
        position: 'relative',
        flex: 1,
        width: '100%',
        height: '100%',
    },
    AlignSelf: (alignSelfProp) => ({
        alignSelf: `${alignSelfProp}`,
    }),
    GuidingLayer: {
        position: 'relative',
    },
    StackLayer: {
        position: 'absolute',
    },
    Fill: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
};
const Stack = (props) => {
    const { children, alignSelf = 'flex-start', anchor = 'topLeft', style } = props;
    const [layerChildren] = findChildren(Stack.Layer, children);
    const styledChildren = React.Children.map(layerChildren, (child, idx) => {
        return idx === 0
            ? React.cloneElement(child, { style: mergeStyles(child.props, S.GuidingLayer, S.AlignSelf(child.props.alignSelf)) })
            : React.cloneElement(child, { style: mergeStyles(child.props, S.StackLayer, anchorMap[child.props.anchor ?? anchor]) });
    });
    return (<Box style={[S.Outer, S.AlignSelf(alignSelf), style]}>
      {styledChildren}
    </Box>);
};
// [TODO]: Consider removing the Layer wrapper
//  - Makes component usage kinda verbose
const Layer = (props) => {
    const { children, style, fill, ...restProps } = props;
    return (<Box style={mergeStyles(props, [S.Fill, fill])} {...restProps}>
      {children}
    </Box>);
};
Stack.displayName = 'Stack';
Layer.displayName = 'Layer';
Stack.Layer = Layer;
export default Stack;
//# sourceMappingURL=Stack.js.map